import Stepper from "../../ui/components/Stepper";
import {
  SETTINGS_WIZARD_OUTER_MAX_WIDTH_PX,
  SETTINGS_WIZARD_STEPPER_GAP_PX,
} from "./settingsWizardConstants";

/**
 * Layout commun stepper + panneau pour les parcours de création Paramètres.
 */
const SettingsCreateWizardLayout = ({
  steps,
  currentIndex,
  maxReachedIndex,
  onStepClick,
  ariaLabel = "Progression",
  stepperClassName = "",
  panelClassName = "",
  contentClassName = "",
  children,
}) => (
  <div
    className={`settings-content-wrapper settings-create-wizard ${contentClassName}`.trim()}
  >
    <div
      className="settings-create-wizard__inner"
      style={{
        maxWidth: SETTINGS_WIZARD_OUTER_MAX_WIDTH_PX,
        gap: SETTINGS_WIZARD_STEPPER_GAP_PX,
      }}
    >
      <Stepper
        steps={steps}
        currentIndex={currentIndex}
        maxReachedIndex={maxReachedIndex}
        onStepClick={onStepClick}
        ariaLabel={ariaLabel}
        className={stepperClassName}
      />
      <div className={`settings-create-wizard__panel ${panelClassName}`.trim()}>
        {children}
      </div>
    </div>
  </div>
);

export default SettingsCreateWizardLayout;
